module.exports = __webpack_public_path__ + "static/media/logo_2_meireles.81f786f0.svg";